// extracted by mini-css-extract-plugin
export default {"arjiv-particles":"style_arjiv-particles__Uk0Oe"};